const $ = require('jquery');
'use strict';
///*------------------------------------------
///*  заказ газона   
///*------------------------------------------
const formGazonHandler = (() => { 
	$(document).on('change', '#order-calculation input[name="valTrFal"]', function() {
	if($(this).val()==="valTrFal_true") {	 
	  $("#order-calculation button[type=submit]").removeAttr('disabled');
	  $('#order-calculation input[type=hidden].valTrFal').val('valTrFal_true');
	}
	else {
		$("#order-calculation button[type=submit]").attr('disabled','disabled');
		$('#order-calculation input[type=hidden].valTrFal').val('valTrFal_disabled');
	}
});
 
$("#order-calculation").submit(function() {
	 if($('#order-calculation input[name="valTrFal"]').val()!=="valTrFal_true") {
	 	$("#order-calculation button[type=submit]").attr('disabled','disabled');
		$('#order-calculation input[type=hidden].valTrFal').val('valTrFal_disabled');
	 }
 const data = $(this).serialize();
	$.ajax({
	type: "POST",
	url: "php/gazon.php",
	data: data,
	success: function(msg) {
		if(msg == 'ok') {
			$('.popup2, .overlay-f').css('opacity','1');
			$('.popup2, .overlay-f').css('visibility','visible');
			$('.popup-f').css({'opacity':'0','visibility':'hidden'});
			$('#order-calculation textarea').val('');
			$(':input','#order-calculation').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
			$('.popup2 .close-modal').click(function () {
				$('.popup-f, .popup2, .overlay-f').css({'opacity':'0', 'visibility':'hidden'});
			});
		}
		else {
			$('.popup2 .window').html(
			'<div class="insText"><h3 class="insText__title">Ошибка</h3><div class="insText__text">Сообщение не отправлено, убедитесь в правильности заполнения полей.</div></div>'); 
			$('.popup2, .overlay-f').css('opacity','1'); 
			$('.popup2, .overlay-f').css('visibility','visible'); 
			$('.popup-f').css({'opacity':'0','visibility':'hidden'});
			$('#order-calculation textarea').val('');
			$(':input','#order-calculation').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
			$('.popup2 .close-modal').click(function () {
				$('.popup-f, .popup2, .overlay-f').css({'opacity':'0', 'visibility':'hidden'});
			});
		} 
	} 
	}); 
	return false; 
	}); 
});
export default formGazonHandler;


// WEBPACK FOOTER //
// ./app/components/form_gazon.js